import { render } from "./TransactionsTab.vue?vue&type=template&id=9f596e7a"
import script from "./TransactionsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionsTab.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Paywall/TransactionsTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9f596e7a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9f596e7a', __exports__)) {
    api.reload('9f596e7a', __exports__)
  }
  
  module.hot.accept("./TransactionsTab.vue?vue&type=template&id=9f596e7a", () => {
    api.rerender('9f596e7a', render)
  })

}


export default __exports__